export default {
    title: 'Recuperar senha',
    instructions: 'Uma mensagem será enviada para seu e-mail para redefinir sua senha.',
    recoverPasswordButton: 'Continuar',
    returnLogindButton: 'Voltar',
    tryAgainButton: 'Tentar novamente',
    success: {
        label: 'A mensagem foi corretamente enviada.',
    },
    email: {
        inputLabel: 'Email'
    }
}